import { useApiMutate, useQueryClient } from "@skanska/vsa-client-auth";
import { ApiEndpoints } from "../models/ApiEndpoints";
import { ApiMethods } from "../models/ApiMethods";

const queryKey = "image-metadata-updater";

export function useImageMetadataUpdater() {
  const queryClient = useQueryClient();
  queryClient.setMutationDefaults([queryKey], { throwOnError: false });

  return useApiMutate<void, void>(
    ApiEndpoints.ImageMetadataUpdater,
    ApiMethods.Post,
    null,
    null,
    [queryKey]
  );
}
